import { render } from "./WaterServices.vue?vue&type=template&id=3f81e24a&scoped=true"
import script from "./WaterServices.vue?vue&type=script&lang=js"
export * from "./WaterServices.vue?vue&type=script&lang=js"

import "./WaterServices.vue?vue&type=style&index=0&id=3f81e24a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f81e24a"]])

export default __exports__